import React, { useEffect, useState } from "react";
import { Modal, Input, Tag, Spin, Empty } from "antd";
import {
  getNudgePreview,
  nudgeAssignee,
} from "../../../services/features/ipPlan.service";
import MessagePopUp from "../Messages/MessagePopUp";
import doneIcon from "../../../Assets/svg/done.svg";
import errorIcon from "../../../Assets/svg/exclamationMark.svg";

const { TextArea } = Input;

// F-08 — PM Nudge tool. Opens a preview of the assignee + missing fields with
// an editable pre-filled message, then sends an in-platform nudge. PM/Admin.
const NudgeModal = ({ open, ipPlanId, ipName, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [msg, setMsg] = useState({ trigger: false, type: "", icon: "", title: "", text: "" });

  const notify = (type, title, text) => {
    setMsg({
      trigger: true,
      type,
      icon: type === "success" ? doneIcon : errorIcon,
      title,
      text,
    });
    setTimeout(() => setMsg((m) => ({ ...m, trigger: false })), 3000);
  };

  useEffect(() => {
    if (!open || !ipPlanId) return;
    setLoading(true);
    setPreview(null);
    getNudgePreview(
      ipPlanId,
      (res) => {
        const data = res?.data || res || null;
        setPreview(data);
        setMessageText(data?.preFilledMessage || "");
        setLoading(false);
      },
      () => {
        notify("danger", "Couldn't load", "Couldn't load nudge details.");
        setLoading(false);
      }
    );
  }, [open, ipPlanId]);

  const send = () => {
    setSending(true);
    nudgeAssignee(
      ipPlanId,
      messageText,
      () => {
        setSending(false);
        notify(
          "success",
          "Nudge sent",
          `Nudge sent${preview?.assigneeName ? ` to ${preview.assigneeName}` : ""}.`
        );
        onClose();
      },
      () => {
        setSending(false);
        notify("danger", "Send failed", "Couldn't send the nudge.");
      }
    );
  };

  return (
    <>
    <MessagePopUp
      trigger={msg.trigger}
      type={msg.type}
      icon={msg.icon}
      messageTitle={msg.title}
      messageText={msg.text}
    />
    <Modal
      open={open}
      title={`Nudge${ipName ? ` — ${ipName}` : ""}`}
      onCancel={onClose}
      onOk={send}
      okText="Send nudge"
      confirmLoading={sending}
      okButtonProps={{ disabled: loading || !preview?.assigneeId, className: "saveButton" }}
      cancelButtonProps={{ className: "cancelButton" }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      ) : !preview ? (
        <Empty description="No preview available" />
      ) : (
        <div>
          <p style={{ marginBottom: 8 }}>
            To: <strong>{preview.assigneeName || "Unassigned"}</strong>{" "}
            {preview.assigneeEmail && (
              <span style={{ color: "#707073" }}>({preview.assigneeEmail})</span>
            )}
          </p>
          {preview.missingFields?.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 12, color: "#707073", marginBottom: 4 }}>
                Missing:
              </div>
              {preview.missingFields.map((f) => (
                <Tag key={f} color="orange">
                  {f}
                </Tag>
              ))}
            </div>
          )}
          <TextArea
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            autoSize={{ minRows: 4, maxRows: 10 }}
            placeholder="Message to the assignee"
          />
        </div>
      )}
    </Modal>
    </>
  );
};

export default NudgeModal;
